import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as hotelActions from './../../../../../../actions/hotelAction';
import * as rateActions from "./../../../../../../actions/rateAction";
import * as payAtHotelActions from "./../../../../../../actions/payAtHotelAction";
import ListHotelRate from './ListHotelRate';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllHotel: () => dispatch(hotelActions.getAllHotels()),
        getListRatesByHotels: (filters) => dispatch(rateActions.getListRatesByHotels(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ListHotelRate));
